//////////// CSS /////////////
import './styles.css';
import ic_nav_pre from './assets/icon/ic_chevron_left_white_48dp.png';
import ic_nav_next from './assets/icon/ic_chevron_right_white_48dp.png';
import ic_search from './assets/icon/ic_search_black.png';
import ic_true from './assets/icon/true.png';
import ic_false from './assets/icon/false.png';

//////////// REACT /////////////
import React from "react";
import { useHistory } from "react-router-dom";
import QRCode from "react-qr-code";

//////////// REDUX | STORE | SERVICE /////////////
import { useDispatch } from 'react-redux';
import { HttpRequest } from '../../service/HttpRequest';
import { showLoad, dismissLoad } from '../../store/slice/loading';

//////////// COMPONENT /////////////
import Modal from './component/action-modal-form';
import ModalViewImage from './component/modal-view-image'

function InsaneTable(props) {
    // locationStack

    // console.log(props);

    const dispatch = useDispatch();
    const history = useHistory();
    const [tableOption, setTableOption] = React.useState(props.option);
    const [stateContentSearch, setStateContentSearch] = React.useState(false);
    const [dataTable, setDataTable] = React.useState([]);
    const headTable = tableOption.mapTable;

    const [page, setPage] = React.useState(1);
    const [pageTotal, setPageTotal] = React.useState(1);
    const [limitRow, setLimitRow] = React.useState(tableOption.api.view.dataReq.count);

    const [examObject, setExamObject] = React.useState({});

    const [stateTable, setStateTable] = React.useState(false);
    const [stateLoading, setStateLoading] = React.useState("");

    // console.log(tableOption);

    // Math.ceil(countPvr.count / 10);

    // const hasFetchedData = React.useRef(false);
    function onRequest() {

        setDataTable([]);

        // console.log("dataReq : ", tableOption.api.view.dataReq);

        HttpRequest(tableOption.api.view.url, tableOption.api.view.dataReq).then(data => {
            // console.log("..");
            // console.log(("HttpRequest: " + tableOption.tableName + "---> "), data);

            if (data.result === "OK") {
                let att_name = Object.keys(data);
                let result = data[att_name[1]];
                let count = data[att_name[2]];
                let total_page = Math.ceil(count / limitRow);
                setPageTotal(total_page);

                if (result.length > 0) {
                    for (let i = 0; i < result.length; i++) {
                        delete result[i].snapshot_filename;
                    }
                    setStateTable(true);
                    setExamObject(result[0]);
                } else {
                    setStateLoading("NO RESULT " + tableOption.tableName);
                }

                setDataTable(result);
            } else {
                setStateTable(false);
                setStateLoading("NO RESPONE");
            }
            dispatch(dismissLoad());
        });
    }

    const onRefresh = React.useCallback(() => { dispatch(showLoad()); onRequest(); }, []);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();
        dispatch(showLoad());
        onRequest();
        return () => {
            // cancel the request before component unmounts
            controller.abort();
        };
    }, [page, limitRow]);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        // console.log("on props change:", props);
        const controller = new AbortController();
        setTableOption(props.option);
        setPage(1);
        setLimitRow(props.option.api.view.dataReq.count);
        onRequest();
        return () => {
            // cancel the request before component unmounts
            controller.abort();
        };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    function twoDigit(n) {
        let number = parseInt(n);
        if (number <= 9) {
            return "0" + number
        } else {
            return "" + number
        }
    }

    function ConvertDate(dateString, type = "datetime") {
        if (dateString) {
            let date = new Date(dateString);
            if (type === "datetime") {
                return twoDigit(date.getDate()) + "/" + twoDigit((date.getMonth() + 1)) + "/" + twoDigit(date.getFullYear()) + ` -- ` + twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
            if (type === "date") {
                return twoDigit(date.getDate()) + "/" + twoDigit((date.getMonth() + 1)) + "/" + twoDigit(date.getFullYear())
            }
            if (type === "time") {
                return twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
        } else {
            return "";
        }
    }

    function onNext() {
        let _page = page + 1;
        if (_page <= pageTotal) {
            setPage(_page);

            let _option = tableOption;
            _option.api.view.dataReq.index = (_option.api.view.dataReq.index + _option.api.view.dataReq.count);

            setTableOption(_option);
        }
    }

    function onPre() {
        let _page = page - 1;
        if (_page > 0) {
            setPage(_page);

            let _option = tableOption;
            _option.api.view.dataReq.index = (_option.api.view.dataReq.index - _option.api.view.dataReq.count);

            setTableOption(_option);
        }
    }

    function onChangeLimitRow(rowNumber) {

        setLimitRow(parseInt(rowNumber));

        let _option = tableOption;
        _option.api.view.dataReq.index = 0;
        _option.api.view.dataReq.count = parseInt(rowNumber);

        setTableOption(_option);
        setPage(1);

    }

    function onPageNavigate(url, data) {
        let option_navigate = { pathname: url }
        option_navigate.state = data;
        history.push(option_navigate);
    }

    function setValueQRcode(sampleValue, mapValue, value) {
        // console.log("sampleValue ----->", sampleValue);
        // console.log("mapValue ----->", mapValue);
        // console.log("value ----->", value);
        let result = sampleValue;
        if (mapValue.length > 0) {
            for (let i = 0; i < mapValue.length; i++) {
                const map = mapValue[i];
                result[map.attName] = value[map.attMap];
            }
        }
        // console.log(result);
        return JSON.stringify(result);
    }

    function getValueById(attCompare, arrForFilter, valueFilter) {
        // console.log(attCompare, arrForFilter, valueFilter);
        let _find = arrForFilter.filter((e) => {
            return e[attCompare] === valueFilter;
        })
        if (_find.length > 0) {
            return _find[0].displayName
        } else {
            return valueFilter
        }
    }

    return (
        (stateTable) ? (
            <div className={"insane-table " + props.className}>
                <div id="normal-content" className={(('collapsible_button ') + (stateContentSearch ? ('collapsible_active') : (null)))} style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="button" style={{ flexGrow: 1, justifyContent: 'flex-start' }} onClick={() => setStateContentSearch(!stateContentSearch)}>
                        <img src={ic_search} alt="ic_search" />Search {tableOption.tableName}
                    </div>
                    {
                        (tableOption.api.insert.enable) ? (
                            <Modal type="insert" data={examObject} api={tableOption.api} reload={onRefresh}
                                map={tableOption.mapTable} titleButton={("+ Add " + tableOption.tableName)} mapTable={headTable}></Modal>
                        ) : (null)
                    }
                </div >
                <div id="normal-content" className={(('content-collapsible ') + (stateContentSearch ? ('collapsible_active') : (null)))}>

                    <div className="row">
                        {
                            tableOption.search.map((search, search_index) => (
                                <div key={search_index} className="box-input">
                                    <span>{search.displayName}</span>
                                    {
                                        (search.element === "input") ? (
                                            <input className="custom-input" type="text"
                                                placeholder={search.placeholder}
                                                onChange={(e) => {
                                                    let _option = { ...tableOption };
                                                    _option.api.view.dataReq[search.reqName] = e.target.value;
                                                    setTableOption(_option);
                                                    // console.log(tableOption.api.view.dataReq[search.reqName]);
                                                }} />
                                        ) : (null)
                                    }
                                    {
                                        (search.element === "datetime-local") ? (
                                            <input className="custom-input" type="datetime-local"
                                                placeholder={search.placeholder}
                                                onChange={(e) => {
                                                    let _option = { ...tableOption };
                                                    if (e.target.value) {
                                                        _option.api.view.dataReq[search.reqName] = (new Date(e.target.value)).toISOString();
                                                    } else {
                                                        _option.api.view.dataReq[search.reqName] = "";
                                                    }
                                                    setTableOption(_option);
                                                    // console.log(tableOption.api.view.dataReq[search.reqName]);
                                                }} />
                                        ) : (null)
                                    }
                                    {
                                        (search.element === "date") ? (
                                            <input className="custom-input" type="date"
                                                placeholder={search.placeholder}
                                                onChange={(e) => {
                                                    let _option = { ...tableOption };
                                                    if (e.target.value) {
                                                        _option.api.view.dataReq[search.reqName] = (new Date(e.target.value)).toISOString();
                                                    } else {
                                                        _option.api.view.dataReq[search.reqName] = "";
                                                    }
                                                    setTableOption(_option);
                                                    // console.log(tableOption.api.view.dataReq[search.reqName]);
                                                }} />
                                        ) : (null)
                                    }
                                    {
                                        (search.element === "select") ? (
                                            <select className="custom-input"
                                                placeholder={search.placeholder}
                                                onChange={(e) => {
                                                    let _option = { ...tableOption };
                                                    _option.api.view.dataReq[search.reqName] = e.target.value;
                                                    setTableOption(_option);
                                                }}>

                                                <option value="">( unset )</option>

                                                {
                                                    search.option.map((j_data, j) => {
                                                        return <option key={j} value={j_data.value}>{j_data.displayName}</option>
                                                    })
                                                }

                                            </select>
                                        ) : (null)
                                    }
                                </div>
                            ))
                        }
                        <button className="custom-input bt_active bt_search"
                            onClick={() => { onRequest(); }}>Search</button>
                    </div>

                </div>
                <div id="normal-content" className="box-table" style={{ overflow: 'unset' }}>
                    <table>
                        <thead>
                            <tr>
                                {
                                    headTable.map((header, header_index) => (
                                        <th key={header_index}>{header.displayName}</th>
                                    ))
                                }
                                {
                                    (tableOption.action.length > 0) ? (<th>ACTION</th>) : (null)
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataTable.map((row, i) => (
                                    <tr key={i}>
                                        {
                                            headTable.map((col, j) => {
                                                if (col.type === "id") {
                                                    if (col.form.element === "select") {
                                                        return <td key={j}>{getValueById("value", col.form.option, row[col.attName])}</td>
                                                    } else {
                                                        return <td key={j}>{row[col.attName]}</td>
                                                    }
                                                } else if (col.type === "text") {
                                                    return <td key={j}>{row[col.attName]}</td>
                                                } else if (col.type === "bt-view-image") {
                                                    if (row[col.attName]) {
                                                        return <td key={j}><ModalViewImage data={row} titleButton="View"></ModalViewImage></td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>No Image</td>
                                                    }
                                                } else if (col.type === "date" || col.type === "datetime" || col.type === "time") {
                                                    return <td key={j}>{ConvertDate(row[col.attName], col.type)}</td>
                                                } else if (col.type === "approve") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} style={{ color: "#1FD606" }}>Approved</td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>Not Approved</td>
                                                    }
                                                } else if (col.type === "boolean") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} ><img src={ic_true} alt="ic_true" /></td>
                                                    } else {
                                                        return <td key={j} ><img src={ic_false} alt="ic_false" /></td>
                                                    }
                                                } else if (col.type === "cover") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} style={{ color: "#1FD606" }}>Cover</td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>-</td>
                                                    }
                                                } else if (col.type === "status") {
                                                    if (row[col.attName]) {
                                                        if (row[col.attName] === "NORMAL") {
                                                            return <td key={j} style={{ color: "#1fd606", fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        } else {
                                                            return <td key={j} style={{ color: "red", fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        }
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>-</td>
                                                    }
                                                } else if (col.type === "text-color") {
                                                    if (row[col.attName]) {
                                                        if (row[col.attName] > 0) {
                                                            return <td key={j} style={{ color: col.color, fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        } else {
                                                            return <td key={j}>{row[col.attName]}</td>
                                                        }
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>0</td>
                                                    }
                                                } else if (col.type === "merge") {
                                                    return <td key={j} style={{ color: col.color, fontWeight: "bolder" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            {
                                                                col.attName.map((att, k) =>
                                                                    (att === "approvedtime") ? (
                                                                        <span key={k} style={{ fontSize: 12, color: "#5d58e0" }}>
                                                                            { ConvertDate(row[att]) }
                                                                        </span>
                                                                    ) : (att === "name") ? (
                                                                        <span key={k} style={{ fontSize: 14, color: "#5d58e0" }}>{ row[att] }</span>
                                                                    ) : (
                                                                        <span key={k}>{row[att]}</span>
                                                                    )
                                                                )
                                                            }
                                                        </div>
                                                    </td>
                                                } else {
                                                    return (null)
                                                }
                                            })
                                        }
                                        {
                                            (tableOption.action.length > 0) ? (
                                                <td>
                                                    {
                                                        tableOption.action.map((action, action_index) => {

                                                            if (action.mode === "page") {
                                                                return <button key={action_index} className="custom-input bt_active bt_search" style={{margin: "auto"}}
                                                                    onClick={() => onPageNavigate(action.option.url, row)}>{action.name}</button>;
                                                            } else if (action.mode === "modal-form") {
                                                                return <Modal key={action_index} type={action.option.type} reload={onRefresh}
                                                                    api={tableOption.api} data={row} titleButton={action.name} mapTable={headTable}></Modal>;
                                                            } else {
                                                                return (null);
                                                            }

                                                        })
                                                    }
                                                </td>
                                            ) : (null)
                                        }
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <div className="tool">
                        {
                            (tableOption.qr) ? (
                                <div style={{ fontSize: 18, color: "red", fontWeight: "bolder" }}>
                                    ** Press [ Ctrl + p ] to Print QRCode {tableOption.tableName}.
                                    Recommend as Set Row table to 12, Before print.
                                </div>
                            ) : (null)
                        }
                        <div style={{ flexGrow: 1 }}></div>
                        <div>Row</div>
                        <input type="number" style={{ marginRight: 20 }} value={limitRow}
                            onChange={(e) => {
                                if (e.target.value < 1) {
                                    onChangeLimitRow(1)
                                } else if (e.target.value > 20) {
                                    onChangeLimitRow(12)
                                } else {
                                    onChangeLimitRow(e.target.value)
                                }
                            }}></input>
                        <div>Page</div>
                        <button onClick={onPre}><img src={ic_nav_pre} alt="ic_pre" /></button>
                        <input type="number" value={page} onChange={(e) => {
                            if (e.target.value > pageTotal) {
                                setPage(parseInt(pageTotal))
                            } else if (e.target.value < 1) {
                                setPage(1)
                            } else {
                                setPage(parseInt(e.target.value))
                            }
                        }}></input>
                        <div> / {pageTotal}</div>
                        <button onClick={onNext}><img src={ic_nav_next} alt="ic_next" /></button>
                    </div>
                </div >
                <div id="print-content">
                    {
                        (tableOption.qr) ? (
                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                                {
                                    dataTable.map((row, i) => (
                                        <div className="box-qr" key={i}
                                            style={{ width: 200, height: 230, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", border: "1px #555 dashed", padding: 15 }}>
                                            <div className="qr-style" ></div>
                                            <p style={{ textAlign: "center", fontSize: "12px", color: "#444", fontWeight: "bold", margin: 0 }}></p>

                                            <QRCode
                                                bgColor={tableOption.qr.option.bgColor}
                                                fgColor={tableOption.qr.option.fgColor}
                                                level={tableOption.qr.option.level}
                                                size={120}
                                                title={tableOption.qr.option.title}
                                                value={setValueQRcode(tableOption.qr.sampleValue, tableOption.qr.mapValue, row)} />

                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "10px 0", fontSize: "12px" }}>
                                                {
                                                    ((tableOption.tableName === "Equipment") || (tableOption.tableName === "Standard Gas")) ?
                                                        <p style={{ textAlign: "center", color: "black", margin: 0, fontSize: 12, fontWeight: "bolder" }}>{row.tagid}</p>
                                                        :
                                                        <p style={{ textAlign: "center", color: "black", margin: 0, fontSize: 10, fontWeight: "bolder" }}>{row.equipmentgroupname}</p>
                                                }
                                                <p style={{ textAlign: "center", margin: 0, fontSize: 10, fontWeight: "bolder", color: "#5d58e0" }}>{tableOption.tableName}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ) : (null)
                    }
                </div>

            </div>
        ) : (
            <div className='no-data'>{stateLoading}</div>
        )
    );
}

export default InsaneTable;